import React from "react";
import { ToastContainer, toast,ToastTransition, Slide, Flip} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeContext } from "../../context/theme.context";
export default class Message  {
  static contextType = ThemeContext;
  private context!: React.ContextType<typeof ThemeContext>;
  public static success(val:string) {
    toast.success(val,{
      autoClose:4000,
      transition:Flip
    });
  }
  public static error(val:string) {
    toast.error(val,{
      autoClose:4000,
      transition:Flip
    });
  }
  public static info(val:string) {
    toast.info(val,{autoClose:4000,transition:Flip});
  }
  public static warning(val:string) {
    toast.warning(val,{autoClose:4000,transition:Flip});
  }
  render() {
    return (
      <div>
        <ToastContainer
        autoClose={6000} />
      </div>
    );
  }
}
